import { HeaderType, HeaderData } from "./headerTypes";
import { formatPriceData } from "./priceFormatter";
import { formatBigNumber } from "@utils/formatBigNumber";

/**
 * 基于key的数据处理逻辑，与对应的源组件保持一致
 */
export const processDataByKey = (data: HeaderData) => {
  switch (data.key) {
    case HeaderType.STOCK_INFO:
      // 使用与PriceHeaderItem完全一致的处理逻辑
      const { current_price, priceChangePercentage24h, price_change } = data;
      // 状态判断逻辑（与PriceHeaderItem一致）
      const isUp = (price_change || 0) > 0;
      const isNull =
        priceChangePercentage24h === null ||
        priceChangePercentage24h === undefined;
      const prefix = isUp ? "+" : "";

      return {
        displayPrice: current_price || 0,
        displayChange: isNull
          ? null
          : `${prefix}${formatBigNumber(priceChangePercentage24h, {
              needFormat: true,
              trimZeros: true,
              precision: 2,
            })}%`,
        displayAbsoluteChange: isNull
          ? null
          : `${prefix}$${formatBigNumber(Math.abs(price_change || 0), {
              needFormat: true,
              trimZeros: true,
              precision: 2,
            })}`,
        displayIsPositive: isUp,
      };

    case HeaderType.PRICE_DISPLAY:
    default:
      // 使用现有的token价格处理逻辑
      return formatPriceData({
        rawPrice: data.current_price || 0,
        rawChangePercent: data.priceChangePercentage24h,
      });
  }
};
